import React from "react";
import LoaderComponent from "../../fragments/loader/LoaderComponent";

const LoaderWrapper = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="menu-overlay menu-open">
        <div className="loader-overlay">
          <LoaderComponent />
        </div>
      </div>
    );
  }
  return <>{children}</>; // restituisce i contenuti normali
};

export default LoaderWrapper;
